// Community Guest Management APIs

// Guest Borrow Item Management APIs

/**
 * @function ApiClient#GetGuestBorrowItemList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetGuestBorrowItemList(cid, options = {}) {
  return await this._get(`/community/${cid}/guest_borrow_item_list`, options);
}

/**
 * @function ApiClient#AddGuestBorrowItem
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} itemName
 * @param {any} options = {}
 */
export async function AddGuestBorrowItem(cid, itemName, options = {}) {
  return await this._post(`/community/${cid}/guest_borrow_item?i=${itemName}`, null, options);
}

/**
 * @function ApiClient#UpdateGuestBorrowItem
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} items
 * @param {any} options = {}
 */
export async function UpdateGuestBorrowItem(cid, items, options = {}) {
  return await this._put(`/community/${cid}/guest_borrow_item`, items, options);
}

/**
 * @function ApiClient#DeleteGuestBorrowItem
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} itemName
 * @param {any} options = {}
 */
export async function DeleteGuestBorrowItem(cid, itemName, options = {}) {
  return await this._delete(`/community/${cid}/guest_borrow_item?i=${itemName}`, options);
}

// Guest Visit Place Management APIs

/**
 * @function ApiClient#GetGuestVisitPlaceList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetGuestVisitPlaceList(cid, options = {}) {
  return await this._get(`/community/${cid}/guest_visit_place_list`, options);
}

/**
 * @function ApiClient#AddGuestVisitPlace
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} placeName
 * @param {any} options = {}
 */
export async function AddGuestVisitPlace(cid, placeName, options = {}) {
  return await this._post(`/community/${cid}/guest_visit_place?p=${placeName}`, null, options);
}

/**
 * @function ApiClient#UpdateGuestVisitPlace
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} places
 * @param {any} options = {}
 */
export async function UpdateGuestVisitPlace(cid, places, options = {}) {
  return await this._put(`/community/${cid}/guest_visit_place`, places, options);
}

/**
 * @function ApiClient#DeleteGuestVisitPlace
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} placeName
 * @param {any} options = {}
 */
export async function DeleteGuestVisitPlace(cid, placeName, options = {}) {
  return await this._delete(`/community/${cid}/guest_visit_place?p=${placeName}`, options);
}

/**
 * @function ApiClient#UpdateGuestToLeave
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} guestID
 * @param {any} options = {}
 */
export async function UpdateGuestToLeave(cid, guestID, options = {}) {
  return await this._put(`/community/${cid}/guest_leave/${guestID}`, null, options);
}

// Guest CRUD APIs

/**
 * @function ApiClient#AddGuest
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} GuestData
 * @param {any} Image
 * @param {any} options = {}
 */
export async function AddGuest(cid, GuestData, Image, options = {}) {
  const formData = new FormData();
  formData.set("Data", JSON.stringify(GuestData));
  if (Image) formData.set("Image", Image, "webcam.jpg");
  return await this._post(`/community/${cid}/guest`, formData, options);
}

/**
 * @function ApiClient#GetGuestListByStatus
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} guestStatus
 * @param {any} options = {}
 */
export async function GetGuestListByStatus(cid, guestStatus, options = {}) {
  return await this._get(`/community/${cid}/guest_list?s=${guestStatus}`, options);
}

/**
 * @function ApiClient#GetGuestList
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.sortBy
 * @param {any} params.sortDesc
 * @param {any} params.page
 * @param {any} params.itemsPerPage
 * @param {any} params.status
 * @param {any} params.startDate
 * @param {any} params.endDate
 * @param {any} params.startDate_check
 * @param {any} params.endDate_check
 * @param {any} params.building
 * @param {any} params.doorPlate
 * @param {any} params.floor
 * @param {any} params.visitPlace
 * @param {any} options = {}
 */
export async function GetGuestList(
  cid,
  { sortBy, sortDesc, page, itemsPerPage, status, startDate, endDate, startDate_check, endDate_check, building, doorPlate, floor, visitPlace },
  options = {},
) {
  if (!startDate_check) startDate_check = "";
  if (!endDate_check) endDate_check = "";
  if (!startDate) startDate = "";
  if (!endDate) endDate = "";
  if (!building) building = "";
  if (!doorPlate) doorPlate = "";
  if (!floor) floor = "";
  if (!visitPlace) visitPlace = "";

  return await this._get(
    `/community/${cid}/guest_list?s=${status}&p=${page}&sb=${sortBy}&sd=${sortDesc}&pp=${itemsPerPage}&st=${startDate}&et=${endDate}&stc=${startDate_check}&etc=${endDate_check}&b=${building}&d=${doorPlate}&f=${floor}&vp=${visitPlace}`,
    options,
  );
}
